<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <div v-if="loading" class="fluid-container app-loading">
      <div class="row align-items-center justify-content-center">
          <div class="col-2 text-center">
              <circle10 size="'50px'"></circle10>
          </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
    import { Circle10 } from 'vue-loading-spinner'
    export default {
      components: {
        Circle10
      },
      computed: {
        loading () {
          return this.$store.state.loading
        }
      },
      data: function () {
        return {
          headerColor: '#f0617d',
          scrollPosition: 155,
          gTagCorporationId: 99,
          html: {
            background: 'yellow !important'
          }
        }
      },
      mounted: function () {
        // Add Google Analytics script
        const script = document.createElement('script')
        script.async = true
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-03CM0WZ1ZN'

        document.head.appendChild(script)

        console.log('in App.vue : user = ', this.user)
        if (this.user && this.user.corporation) { // corporate user, change list list of experts
          this.gTagCorporationId = this.user.corporation.corporationId
        }
        console.log('in App.vue : this.gTagCorporationId = ', this.gTagCorporationId)
        script.onload = () => {
          // Replace 'GA_MEASUREMENT_ID' with your actual GA4 measurement ID
          window.dataLayer = window.dataLayer || []

          function gtag () {
            window.dataLayer.push(arguments)
          }
          // tone dev admin MEASUREMENT ID = G-03CM0WZ1ZN
          gtag('js', new Date())
          gtag('config', 'G-03CM0WZ1ZN')
          gtag('gTagCorporationId', this.gTagCorporationId)
          gtag('event', 'CORPORATION', {
            'corporation_id': this.gTagCorporationId
          })
        }
      }
    }
</script>
<style lang="scss">
  .vue-notifyjs.notifications{
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);

    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue